import { render, staticRenderFns } from "./SharedTable.vue?vue&type=template&id=b97d08e8&"
import script from "./SharedTable.vue?vue&type=script&lang=js&"
export * from "./SharedTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports